import { ActionType } from "../ChatAction";

/**
 * This is not used anymore. It was part of the handshake with the legacy "chat server"
 * 
 * @param token 
 * @returns 
 */
export default function receiveToken(token: string): ActionType {
    return {
        type: "receiveToken",
        detail: {
            token,
            timestamp: +new Date(),
            type: "receiveToken",
            user: undefined
        }
    };
}